namespace Ir.Components.Filters.ComparisonFilter.ComparisonFilterItem {
    interface IViewModel {
        comparisonFilter: ComparisonFilter;
        dateOptionText: KnockoutObservable<string>;
        dateUnitText: KnockoutObservable<string>;
        dateUnitValueVisible: KnockoutObservable<boolean>;
        predefinedCustomDateVisible: KnockoutComputed<boolean>;
        predefinedCustomDateText: KnockoutComputed<string>;



        filterSettingParams: Ir.Components.Workbook.Settings.Items.ComparisonFilterSetting.IComparisonFilterSettingParams;
        showComponent: Function;
    }

    interface IParams {
        comparisonFilter: ComparisonFilter;
        isDrilldownTab: boolean;
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;
        this.comparisonFilter = params.comparisonFilter;
        this.dateOptionText = ko.computed(() => {
            return ComparisonDateOptionEnum[params.comparisonFilter.dateOption()];
        });
        this.dateUnitText = ko.computed(() => {
            if (params.comparisonFilter.dateOption() === ComparisonDateOptionEnum.Predefined) {
                let dateRange = DateRangeService.DatesRange.find(x => x.id() === params.comparisonFilter.dateRange());
                return dateRange?.initials() ?? "";
            }

            return ComparisonDateUnitEnum[params.comparisonFilter.dateUnit()];
        });
        this.dateUnitValueVisible = ko.computed(() => {
            return params.comparisonFilter.dateOption() !== ComparisonDateOptionEnum.Predefined && params.comparisonFilter.dateRange() !== irGlobal.customDate.custom;
        });

        this.predefinedCustomDateVisible = ko.computed(() => {
            return params.comparisonFilter.dateOption() === ComparisonDateOptionEnum.Predefined && params.comparisonFilter.dateRange() === irGlobal.customDate.custom;
        });
        this.predefinedCustomDateText = ko.computed(() => {
            let dateText = "";
            if (self.comparisonFilter.predefinedCustomDate()) {
                let dates = self.comparisonFilter.predefinedCustomDate().split(";");
                let startDate = DevExpress.localization.parseDate(dates[0], "yyyy-MM-dd");
                let startDisplayDate = DevExpress.localization.formatDate(startDate, irSettings.shortDateFormat);                
                let endDate = DevExpress.localization.parseDate(dates[1], "yyyy-MM-dd");
                let endDisplayDate = DevExpress.localization.formatDate(endDate, irSettings.shortDateFormat);

                dateText = `${startDisplayDate} - ${endDisplayDate}`;
            }

            return dateText;
        });

        this.filterSettingParams = {
            comparisonFilter: params.comparisonFilter,
            onComparisonDateOptionChanged(e) {
                if (e.value === ComparisonDateOptionEnum.Manual) {
                    params.comparisonFilter.dateField(null);
                }
            },
            onValueChanged() {
                params.comparisonFilter.isDirty(true);
                if (!params.isDrilldownTab) {
                    workbook.workbookConfig.workbookHelper.applyFiltersDisabled(false);
                }
            },
            filterComparisonDateList(dateOption: ComparisonDateOptionEnum) {
                return dateOption !== ComparisonDateOptionEnum.Manual;
            }
        };

        this.showComponent = function (model, evt) {
            evt.stopPropagation();

            let popover = $('div.comparison-filter-item-component', componentInfo.element).data("dxPopover");
            if (!popover) {
                popover = $('div.comparison-filter-item-component', componentInfo.element).dxPopover({
                    target: $('.comparison-filter-item-container', componentInfo.element),
                    showEvent: 'dxclick',
                    position: 'bottom',
                    hideOnOutsideClick: true,
                    width: 355,
                }).dxPopover("instance");
            }

            popover.toggle();
        };
    }
}